module.exports = __webpack_public_path__ + "static/img/btn_comic_lastpage.d3e6137.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/btn_comic_lastpage.svg
// module id = 10
// module chunks = 0